import { RefObject, useCallback } from 'react';
import { Map } from 'react-leaflet';
import { LatLngTuple } from 'leaflet';

const isOneTuple = (arg: LatLngTuple | LatLngTuple[]): arg is LatLngTuple =>
  typeof arg[0] === 'number';

export const useMapHelpers = (mapRef: RefObject<Map> | null) => {
  const centerMap = useCallback(
    (coordinates: LatLngTuple[] | LatLngTuple) => {
      const map = mapRef?.current?.leafletElement;
      if (!isOneTuple(coordinates)) {
        map?.fitBounds(coordinates);
      } else {
        map?.setView(coordinates, 16);
      }
    },
    [mapRef]
  );

  return {
    centerMap,
  };
};
